export default __webpack_public_path__ + "static/media/38.57bc5a00.svg";